<!--Modal starts-->
<section id="modals">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="content-header">Modals</div>
    </div>
  </div>
  <div class="row text-left" matchHeight="card">
    <!--Modal with Default options starts-->
    <div class="col-sm-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Modal with Default options</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-template #content let-c="close" let-d="dismiss">
              <div class="modal-header">
                <h4 class="modal-title">Modal title</h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p>One fine body&hellip;</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
              </div>
            </ng-template>

            <button class="btn btn-lg btn-outline-primary" (click)="open(content)">Launch demo modal</button>

            <hr>
            <p>Action : {{closeResult}}</p>
          </div>
        </div>
      </div>
    </div>
    <!--Modal with Default options ends-->

    <!--Components as content starts-->
    <div class="col-sm-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Components as content</h4>
          <p>You can pass an existing component as content of the modal window. In this case remember to add content
            component as an <code>entryComponents</code> section of your <code>NgModule</code>.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <button class="btn btn-lg btn-outline-primary" (click)="openContent()">Launch demo modal</button>
          </div>
        </div>
      </div>
    </div>
    <!--Components as content ends-->

    <!--Modal with custom class starts-->
    <div class="col-sm-12 col-md-6 col-lg-4">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Modal with custom class</h4>
          <p>With some style and dark window modal.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-template #customContent let-c="close" let-d="dismiss">
              <div class="modal-header">
                <h4 class="modal-title">Modal title</h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p>Find me here</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
              </div>
            </ng-template>
            <button class="btn btn-lg btn-outline-primary" (click)="openModal(customContent)">Launch demo modal</button>
          </div>
        </div>
      </div>
    </div>
    <!--Modal with custom class ends-->
  </div>
</section>
<!--Modal ends-->
